import React, { useState } from "react";
import { connect } from "react-redux";
import dynamic from "@redux-dynostore/react-redux";
import subspaced from "@redux-dynostore/react-redux-subspace";
import { attachReducer } from "@redux-dynostore/redux-subspace";
import { introductionReducer, mapDispatchToProps } from "./Introduction.store";
import { sendNotification } from "../../../ToastManager/ToastManager";
import Introduction from "../../../library/LCF402/Introduction/Introduction";
import { ToastType } from "../../../ToastManager/constants";
import history from "../../../../modules/history";

export const SmartIntroduction = (props) => {
  const { submitBirthDate } = props;
  const [errorMessage, setErrorMessage] = useState(null);

  const handleSubmit = (params) => {
    submitBirthDate(params)
      .then((response) => {
        sendNotification(response, ToastType.SUCCESS);
        setTimeout(() => {
          history.push("/participant");
        }, 2000);
      })
      .catch((err) => {
        setErrorMessage(err);
      });
  };

  return (
    <Introduction errorMessage={errorMessage} handleSubmit={handleSubmit} />
  );
};

export default dynamic(
  "introductionReducer",
  subspaced({
    mapExtraState: (state) => ({ loginReducer: state.loginReducer }),
  }),
  attachReducer(introductionReducer)
)(connect(null, mapDispatchToProps)(SmartIntroduction));
